// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FavoriteButton_wrap__m4sPU","favorite":"FavoriteButton_favorite__ieAot","withLabel":"FavoriteButton_withLabel__iFWxi","label":"FavoriteButton_label__NAaJB"};